import { render, staticRenderFns } from "./classRoster.vue?vue&type=template&id=734130d8&scoped=true&"
import script from "./classRoster.vue?vue&type=script&lang=js&"
export * from "./classRoster.vue?vue&type=script&lang=js&"
import style0 from "./classRoster.vue?vue&type=style&index=0&id=734130d8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734130d8",
  null
  
)

export default component.exports